import { createClient } from '@supabase/supabase-js';

export const ADMIN_USER_ID = '8a6c4ce5-ae2c-4447-a42e-496d9ef421f4';

export const isAdmin = (userId: string | undefined): boolean =>
  userId === ADMIN_USER_ID;

// Service role client — ONLY for AdminPage Edge Function triggers.
// Safe because: AdminPage is gated by useAdmin() (hardcoded user ID check),
// and the key is only used for Edge Function invocation, not direct DB access.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SERVICE_ROLE_KEY = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY;

export const adminSupabase = SERVICE_ROLE_KEY
  ? createClient(SUPABASE_URL, SERVICE_ROLE_KEY, { auth: { persistSession: false } })
  : null;
